import { AppError } from './AppError';

/**
 * Error thrown when a user is not authorized to perform an action.
 */
export class NotAuthorizedError extends AppError {
  /**
   * Creates a new UnauthorizedError instance.
   * @param message The error message.
   * @param action The action that was attempted.
   * @param requiredRole The role that is required to perform the action.
   */
  constructor(
    message: string = 'Unauthorized',
    action?: string,
    requiredRole?: string
  ) {
    const formattedMessage = action && requiredRole
      ? `${message}: ${action} requires role ${requiredRole}`
      : action
        ? `${message}: ${action}`
        : message;
    
    super(formattedMessage, 'UNAUTHORIZED', true, { action, requiredRole });
    this.name = 'UnauthorizedError';
  }

  /**
   * Creates an UnauthorizedError for a specific action and required role.
   * @param action The action that was attempted.
   * @param requiredRole The role that is required to perform the action.
   * @returns A new UnauthorizedError instance.
   */
  static forAction(action: string, requiredRole?: string): NotAuthorizedError {
    return new NotAuthorizedError(undefined, action, requiredRole);
  }
}